function G1() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Ґ1 Стратегічне управління та розвиток закладу дошкільної освіти
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        Ґ1.1 Здатність до використання інструментів стратегічного планування діяльності закладу дошкільної освіти
                    </td>
                    <td>
                        Ґ1.1.31 Знання особливостей державної, регіональної та місцевої системи управління освітою, векторів державної політики у сфері дошкільної освіти
                    </td>
                    <td>
                        Ґ1.1.У1 Аналізувати зміни державної політики у сфері дошкільної освіти, використовувати результати аналізу в управлінській діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.1.32 Інструменти аналізу функціонування і розвитку закладу освіти
                    </td>
                    <td>
                        Ґ1.2.У2 Визначати сильні та слабкі сторони закладу дошкільної освіти на основі інструментів аналізу стану функціонування і розвитку освіти, 8\УОТ- та РЕ8Т аналізів
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.1.З3 Методи та інструменти збору і обробки інформації
                    </td>
                    <td>
                        ҐІ.З.УЗ Підбирати та застосовувати методи збору інформації та інструменти для вивчення освітніх і управлінських процесів
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        Ґ1.2 Здатність розробляти стратегію закладу освіти з урахуванням інтересів та потреб учасників освітнього процесу
                    </td>
                    <td>
                        Ґ1.2.31 Сутність та цілі розробки стратегії закладу дошкільної освіти
                    </td>
                    <td>
                        Ґ1.2.У1 Визначати цінності, бачення, місію, цілі та критерії, за якими заклад дошкільної освіти визначає подальші напрями розвитку
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.2.32 Етапи та методи розробки стратегії закладу дошкільної освіти
                    </td>
                    <td>
                        Ґ1.2.У2 Розробляти та реалізовувати стратегію діяльності закладу дошкільної освіти як інструменту підвищення якості освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.3 Здатність забезпечити функціонування внутрішньої системи забезпечення якості освіти
                    </td>
                    <td>
                        Ґ.3.31.Загальні вимоги до організації та технології формування внутрішньої системи забезпечення якості освіти у закладі дошкільної освіти
                    </td>
                    <td>
                        Ґ1.3.У1 Дотримуватися вимог організації та ефективного функціонування внутрішньої системи забезпечення якості освіти у закладі дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.4 Здатність створювати умови для здійснення дієвого та відкритого іромадського нагляду (контролю) за діяльністю закладу дошкільної освіти
                    </td>
                    <td>
                        Ґ1.4.31. Забезпечення прозорості та інформаційної відкритості закладу дошкільної освіти
                    </td>
                    <td>
                        ҐІ.4.У1 Забезпечувати відкритий доступ до інформації про діяльність закладу дошкільної освіти шляхом її оприлюднення на своїх офіційних веб-сайтах
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ1.5 Здатність створювати умови для громадського самоврядування в закладі дошкільної освіти
                    </td>
                    <td>
                        Ґ1.5.31 Повноваження, відповідальність, засади формування та діяльності органів громадського самоврядування в закладі дошкільної освіти
                    </td>
                    <td>
                        Ґ1.5.У1 Створювати умови для діяльності органів громадського самоврядування в закладі дошкільної освіти
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {G1}